import WelcomeScreen from 'features/auth/welcome/WelcomeScreen';
import React from 'react';

export default function WelcomePage() {
  return <WelcomeScreen />;
}
